export const LOCATION_SEARCH_PREFIX = "Where are you staying?";
export const LOADING_TEXT = "Loading";
export const WHERE_TO = "Where to?";
export const HOTELS = "Hotels";
